import { debounce }         from 'lodash-es';
import { getElementOffset } from './_utils';

export default class AdfSideToc
{

    constructor ()
    {

        this.sideToc = document.querySelector( '.keywords-menu' );

        if ( !this.sideToc )
        {
            return;
        }

        this.allTocLinks   = this.sideToc.querySelectorAll( 'a' );
        this.keywordGroups = document.querySelectorAll( '.keywords-group' );

        this.bindEvents()
        this.setupTocHighlighting();


    }


    bindEvents ()
    {

        this.sideToc.addEventListener( 'mouseenter', ( event ) =>
        {


        } );


        Array.from( this.allTocLinks )
            .forEach( ( el, i ) =>
            {

                [ 'touchstart', 'touchmove' ].forEach( ( event, j ) =>
                {
                    el.addEventListener( event, this.touchHandle.bind( this ) );
                } )

            } )

    }

    touchHandle ( event )
    {
        // const touched     = event.target;
        // const elementType = touched.type;


        const myLocation = event.touches[ 0 ];
        const realTarget = document.elementFromPoint( myLocation.clientX, myLocation.clientY );


        event.preventDefault();

        if ( realTarget === null || typeof realTarget.type === 'undefined' )
        {
            return;
        }

        Array.from( this.allTocLinks )
            .forEach( ( el, i ) =>
            {
                if ( el === realTarget )
                {
                    // console.log( 'I think we are on ', el, event );

                    el.classList.add( 'active' );
                } else
                {
                    el.classList.remove( 'active' );
                }


            } );


        // this.debouncedNav =    debounce( () =>
        //      {
        //
        //          Array.from( this.allTocLinks )
        //              .forEach( ( el, i ) =>
        //              {
        //                  el.classList.remove( 'active' );
        //              } );

        const href         = realTarget.getAttribute( 'href' );
        const foundElement = document.querySelector( href );

        if ( foundElement )
        {
            window.scrollTo( {
                top      : getElementOffset( foundElement ).top - 80,
                left     : 0,
                behavior : 'smooth',
            } );

        }
        //
        // }, 500 );
        //
        //
        // this.debouncedNav();

    }


    touchStart ( event )
    {
        //console.log( 'touchstart', event.target, event );
    }

    touchMove ( event )
    {
        //console.log( 'touchmove', event.target, event );
    }


    setupTocHighlighting ()
    {
        this.tocObserver = new IntersectionObserver( entries =>
        {
            entries.forEach( entry =>
            {
                const id = entry.target.getAttribute( 'id' );

                if ( entry.intersectionRatio > 0 )
                {
                    Array.from( this.allTocLinks )
                        .filter( el => el.getAttribute( 'href' ) === ('#' + id) )
                        .forEach( ( found, i ) =>
                        {
                            found.classList.add( 'current-section' );
                        } );
                } else
                {
                    Array.from( this.allTocLinks )
                        .filter( el => el.getAttribute( 'href' ) === ('#' + id) )
                        .forEach( ( found, i ) =>
                        {
                            found.classList.remove( 'current-section' );
                        } )
                }
            } );
        } );

        // Track all sections that have an `id` applied
        this.keywordGroups.forEach( ( section ) =>
        {
            this.tocObserver.observe( section );
        } );
    }
}
